import { makeStyles } from "@material-ui/styles";
import Home from "../../../images/home_img.svg";
const useStyles = makeStyles((theme) => ({
  welcome: {
    padding: 4,
    display: "flex",
    alignItems: "center",
    width: "fit-content",
  },
  avatar: {
    marginLeft: ".6em",
    width: theme.spacing(10),
    height: theme.spacing(10),
    position: "absolute",
    left: "31%",
    bottom: "85%",
  },
  imageWelcome: {
    position: "relative",
    width: "100%",
    height: 300,
    borderRadius: 20,
  },
  user: {
    display: "flex",
    alignItems: "center",
    marginLeft: "15%",
  },
  infoUser: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
  },
  icon: {
    color: "#4D8D9D",
    " & .material-icons-outlined": {
      fontSize: 40,
    },
  },
  styleTitles: {
    fontSize: 16,
    color: "#003D51",
    margin: "64px 0px 32px 0px",
  },
  containerAtajos: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flexWrap: "nowrap",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    height: 108,
    width: 131,
  },
  titleAcces: {
    fontSize: 13,
    textAlign: "center",
    top: -10,
    position: "relative",
  },
  buttonCloseSession: {
    margin: "10% 0px",
    justifyContent: "center",
    marginLeft: "16%",
    background: "#D3EEF5",
    width: 193,
    "&:hover": {
      color: "#217B98",
      background: "#D3EEF5",
    },
  },
  textNotificaion: {
    fontSize: 14,
    fontFamily: "Roboto",
    margin: "auto",
  },
  settings: {
    cursor: "pointer",
    fontSize: 12,
    color: "#217B98",
    textDecoration: "none",
  },
  wrapperNotification: {
    display: "flex",
    margin: "0px 2%",
    justifyContent: "space-evenly",
  },
  imageHome: {
    backgroundImage: `url(${Home})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    height: 300,
    backgroundPositionX: 15,
    borderRadius: 10,
    //paddingRight: 20,
  },
  userName: {
    textAlign: "center",
    paddingTop: "18%",
    fontSize: 12,
    color: "#217B98",
    margin: "0px 85px",
  },
}));

export default useStyles;
